import { useEffect, useMemo, useState } from 'react';
import Avatar from '@mui/material/Avatar';

const versionedUrl = (url, version) => {
    if(!url) return url;
    if(!version) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${version}`;
}

const getAvatarSize = (style = {}) => {
    const size = style.width || style.height || 40;
    if(typeof size === 'number') return size;
    if(typeof size === 'string' && size.endsWith('px')) return Number(size.replace('px', ''));
    return 40;
}

const getInitials = (name) => {
    if(!name) return '';
    return name.trim().split(" ").map((n)=>n[0].toUpperCase()).join("");
}

export function MyAvatar(props) {
    const propsStyle = props.style ? props.style : {};
    const userAccount = props.userAccount || {};
    const src = props.src || userAccount.avatarUrl;
    const profilePicUrl = props.profilePicUrl || userAccount.profilePicUrl;
    const avatarOptions = props.avatarOptions || userAccount.avatarOptions;
    const name = props.name || userAccount.displayName || userAccount.name;
    const croppedAreaPixels = avatarOptions && avatarOptions.croppedAreaPixels;
    const hasCroppedProfilePic = profilePicUrl && croppedAreaPixels;
    const imageVersion = props.imageVersion || userAccount.avatarVersion;
    const avatarSrc = useMemo(() => versionedUrl(src, imageVersion), [src, imageVersion]);
    const profileSrc = useMemo(() => versionedUrl(profilePicUrl, imageVersion), [profilePicUrl, imageVersion]);
    const [imageSize, setImageSize] = useState(null);

    useEffect(() => {
        if(!profilePicUrl || !croppedAreaPixels) return;

        const image = new Image();
        image.onload = () => setImageSize({width: image.naturalWidth, height: image.naturalHeight});
        image.src = profileSrc;
    }, [profilePicUrl, profileSrc, croppedAreaPixels]);

    if(!src && !profilePicUrl && !name) return <Avatar style={propsStyle}/>;

    if(hasCroppedProfilePic && imageSize){
        const avatarSize = getAvatarSize(propsStyle);
        const scale = avatarSize / croppedAreaPixels.width;
        const imageStyle = {
            position:'absolute',
            width:imageSize.width * scale,
            height:imageSize.height * scale,
            left:-croppedAreaPixels.x * scale,
            top:-croppedAreaPixels.y * scale,
            maxWidth:'none',
        };

        return (
            <Avatar style={{...propsStyle, position:'relative', overflow:'hidden'}}>
                <img src={profileSrc} alt={name || 'Avatar'} style={imageStyle}/>
            </Avatar>
        );
    }

    if(src && !hasCroppedProfilePic) return <Avatar src={avatarSrc} style={propsStyle}/>;
    
    return <Avatar style={propsStyle}>{getInitials(name)}</Avatar>;
}
